// extracted by mini-css-extract-plugin
export var content = "LangNotificationModal-module--content--054a2";
export var fadeInAnimation = "LangNotificationModal-module--fadeInAnimation--9ad43";
export var link = "LangNotificationModal-module--link--88808";
export var subtitle = "LangNotificationModal-module--subtitle--976ad";
export var title = "LangNotificationModal-module--title--f8fe3";